import React, { useState } from 'react';
import { th } from 'date-fns/locale';
import { formatWithOptions } from 'date-fns/fp';
import IdField from '../idField/IdField';
import GenderRadio from '../genderRadio/GenderRadio';
import ListingItem from '../listingItem/ListingItem';
import { CustomCheckbox } from '../../../../common';
import { AMWAY_BUSINESS_LISTING, AMWAY_BUSINESS_LISTING_BTN, AMWAY_BUSINESS_LISTING_HEADING, AMWAY_MEMBER_LISTING, AMWAY_MEMBER_LISTING_BTN, AMWAY_MEMBER_LISTING_HEADING, FIELD_TYPE, LABEL_ACCEPT_TNC, LABEL_ACCEPT, LABEL_BACK } from '../../../../common/commonConstant';
import { TermsConditionsContent } from '../../../condition/TermsConditions';
import './PublicForm.scss';
import config from '../../../../config';

const liff = window.liff;

export default function PublicForm({ name, lastname, gender, phone,
  birthday, onTextChange, onMobileChange, onGenderChange, onDobSubmit, onDobDelete, showError, phoneValidationError, accept, onAcceptChange }) {

  const [errorObj, setErorObj] = useState({});
  const [showConditionModal, setShowConditionModal] = useState(false);

  const handleErrorObj = ({ name, error }) => {
    const newErrorObj = { ...errorObj, [name]: error };
    setErorObj(newErrorObj);
    let errorString = Object.values(newErrorObj).find((errorValue) => errorValue) || '';
    showError(errorString);
  }


  const onPaste = e => {
    e.preventDefault();
    return false;
  };

  const handleABOMemberClick = e => {
    e.preventDefault();
    liff.openWindow({
      url: `${config.NGC_SF_URL}/signup?flowName=selfInitiatedFlow&returnUri=/cart`,
      external: false
    })
  }

  const handleOpenConditionModal = () => {
    setShowConditionModal(true);
  }

  const handleAcceptCondition = () => {
    if (!accept) {
      onAcceptChange();
    }
    setShowConditionModal(false);
  }

  const handleCloseConditionModal = () => {
    setShowConditionModal(false);
  }

  if (showConditionModal) {
    return (
      <div className="condition-modal-container">
        <div className="condition-modal-content">
          <TermsConditionsContent />
          <div className="condition-modal-buttons">
            {accept
              ? <button type="button" className="condition-modal-btn back" onClick={handleCloseConditionModal}>{LABEL_BACK}</button>
              : <>
              <button type="button" className="condition-modal-btn accept" onClick={handleAcceptCondition} style={{marginRight:"24px", width:"128px"}}>{LABEL_ACCEPT}</button>
              <button type="button" className="condition-modal-btn back" onClick={handleCloseConditionModal} style={{width:"128px"}}>{LABEL_BACK}</button>
              </>
            }
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="form-public home-form-wrapper">
      <IdField
        heading="ชื่อ"
        type="text"
        id="name"
        name="name"
        required
        maxLength="25"
        onChange={onTextChange}
        onPaste={onPaste}
        value={name}
        regex={/^(?!.*[\u0E3F\u0E50-\u0E59])[A-Za-z\u0E00-\u0E4E]{1,50}$/}
        errorText='กรุณาระบุข้อมูลด้วยตัวอักษรเท่านั้น'
        showError={handleErrorObj}
        placeholder="ระบุชื่อ"
        preIconPath='/images/common/AccountIcon.svg'
        preIconDisabledPath='/images/common/AccountIconDisabled.svg' />
      <IdField
        heading="นามสกุล"
        type="text"
        id="lastname"
        name="lastname"
        required
        maxLength="25"
        onChange={onTextChange}
        onPaste={onPaste}
        value={lastname}
        regex={/^(?!.*[\u0E3F\u0E50-\u0E59])[A-Za-z\u0E00-\u0E4E]{1,50}$/}
        errorText='กรุณาระบุข้อมูลด้วยตัวอักษรเท่านั้น'
        showError={handleErrorObj}
        placeholder="ระบุนามสกุล"
        preIconPath='/images/common/AccountIcon.svg'
        preIconDisabledPath='/images/common/AccountIconDisabled.svg' />
      <div className="registration-id-field-heading">เพศ</div>
      <div className="radio-panel">
        <GenderRadio name="gender" value="male" checked={gender === 'male'} onChange={onGenderChange} />
        <GenderRadio name="gender" value="female" checked={gender === 'female'} onChange={onGenderChange} />
      </div>
      <IdField
        type={FIELD_TYPE.Date}
        heading="วันเกิด"
        placeholder="เลือกวันเกิด"
        value={birthday && formatWithOptions({ locale: th }, 'd MMMM yyyy')(birthday)}
        onDateSubmit={onDobSubmit}
        onDateDelete={onDobDelete}
        preIconPath='/images/common/CalendarIcon.png'
        preIconDisabledPath='/images/common/CalendarIconDisabled.png'
        disableFutureDates={true} />
      <IdField
        heading="เบอร์โทรศัพท์"
        type="tel"
        value={phone}
        regex={/[0]{1}[6-9]{1}[0-9]{1}[0-9]{7}/}
        id="phone"
        name="phone"
        required
        maxLength="10"
        onChange={onMobileChange}
        onPaste={onPaste}
        placeholder="ระบุเบอร์โทรศัพท์"
        preIconPath='/images/common/PhoneIcon.svg'
        preIconDisabledPath='/images/common/PhoneIconDisabled.svg' />
      {typeof phoneValidationError == "string" && <div className="phone-validation-error">{phoneValidationError}</div>}
      <div className="form-public-business-value-sub_heading">ข้อมูลส่วนตัวของท่านจะได้รับการปกป้องอย่างปลอดภัย</div>
      <div className="form-public-business-value-heading">รับสิทธิพิเศษที่มากกว่าเดิม!</div>
      <div className="form-public-business-listing">
        <div className="form-public-business-listing-heading">{AMWAY_BUSINESS_LISTING_HEADING}</div>
        {
          AMWAY_BUSINESS_LISTING.map((title) => <ListingItem title={title} />)
        }
        <button type='button' onClick={handleABOMemberClick} className="form-public-listing-button">{AMWAY_BUSINESS_LISTING_BTN}</button>
      </div>
      <div className="form-public-member-listing">
        <div className="form-public-member-listing-heading">{AMWAY_MEMBER_LISTING_HEADING}</div>
        {
          AMWAY_MEMBER_LISTING.map((title) => <ListingItem title={title} />)
        }
        <button type='button' onClick={handleABOMemberClick} className="form-public-listing-button">{AMWAY_MEMBER_LISTING_BTN}</button>
      </div>
      <div className="home-registration-tnc-wrapper">
        <CustomCheckbox onChange={onAcceptChange} accept={accept} />
        <div className="home-registration-tnc-link">
          <div className="link" onClick={handleOpenConditionModal}>{LABEL_ACCEPT_TNC}</div>
        </div>
      </div>
    </div>
  )
}
